import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Shield, Compass, Mountain, Target } from "lucide-react";
import Article from "../components/Article";
import Banner from "../components/Banner";
import Location from "../components/Location";
import Sidebar from "../components/Sidebar";
// import Video from "../components/Video";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";
import mountains from "../assets/images/image17.jpg";
import murgab from "../assets/images/murgab.jpg";
import shurabad from "../assets/images/shurabad.jpg";
import nurek from "../assets/images/nurek.jpg";
import { locationKeys, locationImages } from "../assets/constants/locations";

const imageMap = { murgab, shurabad, nurek };

const inclusionKeys = [
  { key: "permits", Icon: Shield },
  { key: "guides", Icon: Compass },
  { key: "camps", Icon: Mountain },
  { key: "export", Icon: Target },
];

function Experience() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div>
      <Header onOpenSidebar={() => setSidebarOpen(true)} />
      <Banner
        image={mountains}
        title={t("experience.bannerTitle")}
        onOpenSidebar={() => setSidebarOpen(true)}
      />
      {/* <Video /> */}
      <Article />
      <div className="py-8 sm:py-14 px-4">
        <div className="border border-black"></div>
        <p className="py-6 sm:py-8 text-center text-2xl sm:text-3xl lg:text-4xl font-semibold">
          {t("experience.reserveTitle")}
        </p>
        <div className="border border-black"></div>
      </div>
      {locationKeys.map((key, i) => (
        <Location
          key={key}
          height={720}
          position={i % 2 === 0 ? "left" : "right"}
          image={imageMap[locationImages[key]]}
          fit={"contain"}
          title={t(`locations.${key}.title`)}
          subtitle={t(`locations.${key}.subTitle`)}
          description={t(`locations.${key}.description`)}
          subDescription={t(`locations.${key}.subDescription`, {
            defaultValue: "",
          })}
          location={t(`locations.${key}.location`)}
          attitude={t(`locations.${key}.attitude`)}
        />
      ))}

      <section className="bg-[#f4f1ec] py-16 sm:py-24 px-4">
        <div className="max-w-6xl mx-auto">
          <Reveal
            as="p"
            direction="up"
            className="text-sm sm:text-base uppercase tracking-[0.3em] text-yellow-600 text-center mb-4"
          >
            {t("experience.inclusions.kicker")}
          </Reveal>
          <Reveal
            as="h2"
            direction="up"
            delay={0.15}
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#223746] text-center mb-4"
          >
            {t("experience.inclusions.title")}
          </Reveal>
          <Reveal
            as="p"
            direction="up"
            delay={0.3}
            className="text-sm sm:text-base text-[#223746]/80 text-center max-w-2xl mx-auto mb-14 sm:mb-16"
          >
            {t("experience.inclusions.body")}
          </Reveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {inclusionKeys.map(({ key, Icon }, idx) => (
              <Reveal
                key={key}
                direction="up"
                delay={idx * 0.1}
                className="text-center"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 border border-yellow-600/40 mb-5">
                  <Icon size={28} className="text-yellow-600" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-[#223746] mb-3 uppercase tracking-widest">
                  {t(`experience.inclusions.items.${key}.title`)}
                </h3>
                <p className="text-sm text-[#223746]/80 leading-relaxed">
                  {t(`experience.inclusions.items.${key}.body`)}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section
        style={{ backgroundImage: `url(${mountains})` }}
        className="relative h-[420px] sm:h-[520px] bg-cover bg-center md:bg-fixed overflow-hidden"
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
          <Reveal
            as="p"
            direction="up"
            className="text-yellow-500 text-xs sm:text-sm uppercase tracking-[0.4em] mb-5"
          >
            {t("experience.closing.kicker")}
          </Reveal>
          <Reveal
            as="h2"
            direction="up"
            delay={0.15}
            className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-wider max-w-3xl mb-8"
          >
            {t("experience.closing.title")}
          </Reveal>
          <Reveal direction="up" delay={0.3}>
            <a
              href="https://wa.me/992987911110"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center border border-white px-10 py-3 text-sm font-semibold tracking-widest uppercase text-white cursor-pointer hover:text-[#223746] hover:bg-white transition-colors duration-200"
            >
              {t("common.inquire")}
            </a>
          </Reveal>
        </div>
      </section>

      <Footer />
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
    </div>
  );
}

export default Experience;
